
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hallticket",
      function () {
        return require("private-next-pages/hallticket/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hallticket"])
      });
    }
  